<template>
    <!-- 楼层背景图 -->
    <div>
        <!-- 社群活码楼层 -->
        <div v-if="pageType === 'communitycode' && picturesData.filePath && picturesData.qrCodeImgUrl"
            :id="uid"
            class="contnet"
            :style="{ 'background-image': 'url('+ picturesData.filePath +')','padding-top': aspectRatio}">
            <!-- 已登录 -->
            <div v-if="isLoginFlag"
                class="contnet_img"
                :style="{ 'background-image': 'url('+ picturesData.qrCodeImgUrl +')'}">
                <img class="code_img"
                    :src="picturesData.qrCodeImgUrl"
                    alt="">
            </div>
            <!-- 未登录 -->
            <div v-else
                class="default-img">
                <img :src="defaultImageUrl"
                    alt="">
            </div>
        </div>
        <!-- 企微导购活码楼层 -->
        <div v-if="pageType === 'guidecode' && picturesData.filePath"
            class="contnet"
            :style="{ 'background-image': 'url('+ picturesData.filePath +')','padding-top': aspectRatio}"
            @click="goToMiniPage()">
        </div>
    </div>
</template>

<script>
import utils from '../../../../utils/comUtils.js';
import wx from 'weixin-js-sdk';
export default {
  props: {
    picturesData: Object,
    loginType: {
      type: String,
      default: 'none',
    },
    activityCode: {
      type: String,
      require: true,
    },
    channelCode: {
      type: String,
      default: '',
    },
    isLoginFlag: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      aspectRatio: '46%',
      uid: `liveCodePicture_${Date.now()}`,
      defaultImageUrl: 'static/runtime/images/magic/no-login-qrcode.png',
    };
  },
  watch: {
    picturesData: {
      deep: true,
      handler(newVal) {
        if (newVal.qrCodeImgUrl && newVal.filePath) {
          this.$nextTick(() => {
            console.log('set touchend event');
            const container = document.getElementById(this.uid);
            container && container.addEventListener('touchstart', this.reportEvent);
          });
        }
      },
    },
  },
  created() {
    // 图片宽高比
    const img = document.createElement('img');
    img.src = this.picturesData.filePath;
    img.onload = () => {
      this.aspectRatio = (img.height / img.width).toFixed(2) * 100 + '%';
    };
  },
  beforeDestroy() {
    console.log('销毁组件前，移除事件监听');
    const container = document.getElementById(this.uid);
    container && container.removeEventListener('touchstart', this.reportEvent);
  },
  methods: {
    reportEvent() {
      let actionCode = '';
      let actionName = '';
      if (this.pageType === 'guidecode') {
        actionCode = '400060009';
        actionName = '企微导购活码楼层';
      } else if (this.pageType === 'communitycode') {
        actionCode = '400060013';
        actionName = '社群活码楼层';
      }
      const params = {
        actionCode,
        actionName,
        content: {
          title: actionName,
          channel: this.loginType == 'none' ? '无需登录' : this.loginType == 'wechat' ? '微信' : '支付宝',
          activityCode: this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      utils.handleBatchReport(this, params);
      if (this.pageType === 'communitycode' && this.isLoginFlag) {
        // 登录后，社群活码楼层记录扫码次数
        this.communityScan();
      }
    },
    // 社群扫码
    communityScan() {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'miniMemberAndCommunityStatistics/communityScan',
        params: {
          activityCode: this.activityCode,
          channel: '1', //渠道 1、活力魔方活动 2、门店WIFI 3、企业微信小程序 4、荣耀+app（店员开单） 5、门店扫描 6、微信小程序 7、支付宝小程序
          channelCode: this.channelCode,
        },
        success: (r) => {
          console.log('识别社群二维码', r);
        },
      });
    },
    // 跳转到小程序
    goToMiniPage() {
      if (this.pageType === 'guidecode') {
        this.reportEvent();
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/nearShoppers/add-shopper?endId=magicActivity&aggregationCodeId=${this.picturesData.couponcodesOrSpuids}`,
        });
      }
    },
  },
};
</script>


<style scoped lang="scss">
img {
  width: 100%;
  display: block;
}
.contnet {
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 0px;
}
.bg_img {
  display: block;
  width: 100%;
  position: relative;
}
.contnet_img {
  position: absolute;
  width: 27.5vw;
  height: 27.5vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 4px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.default-img {
  position: absolute;
  width: 27.5vw;
  height: 27.5vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    width: 100%;
    height: 100%;
  }
}
.code_img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 4px;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/live-code-picture.vue